import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy URL → current canonical page
export const Route = createFileRoute("/cyber-security-services-montclair")({
  beforeLoad: () => {
    throw redirect({ href: "/services/cyber-security", statusCode: 301 });
  },
});
